module.exports = __webpack_public_path__ + "media/images/representatives-ff5ec1a8a7badab871ab20a1dda3ad6a.png";